import { render, staticRenderFns } from "./JCron.vue?vue&type=template&id=04bb2123&scoped=true&"
import script from "./JCron.vue?vue&type=script&lang=js&"
export * from "./JCron.vue?vue&type=script&lang=js&"
import style0 from "./JCron.vue?vue&type=style&index=0&id=04bb2123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb2123",
  null
  
)

export default component.exports